import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07aaebf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title d-flex flex-row align-items-center",
  style: {"flex":"1"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "View flow execution: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-sync" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body p-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Input data", -1))
const _hoisted_11 = {
  key: 0,
  class: "table table-data table-sm table-striped"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Activity", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "header" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-timer" }),
  /*#__PURE__*/_createTextVNode(" Block Start: ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-stopwatch" }),
  /*#__PURE__*/_createTextVNode(" Block Active: ")
], -1))
const _hoisted_18 = ["title"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa-duotone fa-fw fa-right-to-bracket" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa-duotone fa-fw fa-right-from-bracket" }, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "table table-data table-sm table-striped"
}
const _hoisted_23 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.context)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.formatDateAgo(_ctx.context.start_time)) + " (" + _toDisplayString(_ctx.formatDate(_ctx.context.start_time)) + ") ", 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-transparent btn-refresh",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getLogs && _ctx.getLogs(...args)))
              }, _hoisted_8),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'automation-flows-edit' })))
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              (_ctx.context.params)
                ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.params, (value, key) => {
                        return (_openBlock(), _createElementBlock("tr", { key: key }, [
                          _createElementVNode("th", null, _toDisplayString(key), 1),
                          _createElementVNode("td", null, _toDisplayString(value), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.stack, (stack, stackIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: stackIdx,
                  class: "log-item"
                }, [
                  _createElementVNode("img", {
                    src: _ctx.vm.getIconUrl(stack.object.icon)
                  }, null, 8, _hoisted_13),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", null, _toDisplayString(stack.object.title), 1),
                      _createElementVNode("div", null, [
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateAgo(stack.start_time)) + " (" + _toDisplayString(_ctx.formatDate(stack.start_time)) + ") ", 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_17,
                        _createElementVNode("span", {
                          title: _ctx.formatDate(stack.active_time)
                        }, _toDisplayString(_ctx.formatDateDiff(stack.start_time, stack.active_time)), 9, _hoisted_18)
                      ]),
                      _createElementVNode("div", null, [
                        (stack.fromConnection)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_19, [
                              _hoisted_20,
                              _createTextVNode(" " + _toDisplayString(stack.fromConnection), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, [
                          _hoisted_21,
                          _createTextVNode(" " + _toDisplayString(stack.toConnections.join(', ')), 1)
                        ])
                      ])
                    ]),
                    (stack.data)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stack.data, (value, key) => {
                              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                _createElementVNode("th", null, _toDisplayString(key), 1),
                                _createElementVNode("td", null, _toDisplayString(value), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light",
                "data-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'automation-flows-edit' })))
              }, "Close")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}